import styles from "./Badge.module.css";

/** tone: neutral | success | warning | danger | info | honey */
export function Badge({ tone = "neutral", children, className = "" }) {
  return <span className={[styles.badge, styles[tone], className].filter(Boolean).join(" ")}>{children}</span>;
}
